


















import {Component} from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import {TagHelper} from '@/mixins/TagHelper';

@Component({
    components: {Button}
})
export default class extends TagHelper {
    selectedTags: string[] = [];

    get tags() {
        return this.$store.state.TagList;
    }

    created() {
        this.$store.commit('fetchTags');
    }

    activeClass(tag: string) {
        const index = this.selectedTags.indexOf(tag);
        if (index >= 0) {

            this.selectedTags.splice(index, 1);
            console.log(this.selectedTags);
        } else {
            this.selectedTags.push(tag);
            this.$emit('update:value', this.selectedTags);

        }

    }




}

